import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseConfig } from '@fuse/types/fuse-config';
import { NavigationItemInterface } from 'app/layout/components/navigation/models/navigation-item-interface';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { NavigationComponent } from '../../../navigation/navigation.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
  selector: 'app-navbar-vertical-style-2',
  styleUrls: ['./style-2.component.scss'],
  templateUrl: './style-2.component.html',
  imports: [NgClass, MatIcon, MatIconButton, NavigationComponent],
})
export class NavbarVerticalStyle2Component implements OnInit, OnDestroy {
  public fuseConfig: FuseConfig;
  public navigation: NavigationItemInterface[] | undefined;

  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _fuseConfigService = inject(FuseConfigService);
  private _fuseNavigationService = inject(FuseNavigationService);
  private _fuseSidebarService = inject(FuseSidebarService);
  private _router = inject(Router);
  private _unsubscribeAll$: Subject<void> = new Subject();

  public ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  public ngOnInit(): void {
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this._unsubscribeAll$),
      )
      .subscribe(() => {
        if (this._fuseSidebarService.getSidebar('navbar')) {
          this._fuseSidebarService.getSidebar('navbar')!.close();
        }
      });

    // Get current navigation
    this._fuseNavigationService.onNavigationChanged
      .pipe(
        filter((value) => value !== null),
        takeUntil(this._unsubscribeAll$),
      )
      .subscribe(() => {
        this.navigation = this._fuseNavigationService.getCurrentNavigation();
        this._changeDetectorRef.markForCheck();
      });

    // Subscribe to the config changes
    this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll$)).subscribe((config) => {
      this.fuseConfig = config;
      this._changeDetectorRef.markForCheck();
    });
  }

  /**
   * Toggle sidebar folded status
   */
  public toggleSidebarFolded(): void {
    this._fuseSidebarService.getSidebar('navbar')!.toggleFold();
  }

  /**
   * Toggle sidebar opened status
   */
  public toggleSidebarOpened(): void {
    this._fuseSidebarService.getSidebar('navbar')!.toggleOpen();
  }

  /**
   * TouchEnd event
   */
  public touchUnfoldTemporarily(touchUnfold: boolean): void {
    this._fuseSidebarService.getSidebar('navbar')!.touchUnfoldTemporarily(touchUnfold);
  }
}
